import { requestGQL } from 'common/graphQlClient';
import { useMutation, useQueryClient } from 'react-query';

import { allPremisesKey } from 'app/premises/hooks/usePremisesList';
import { DELETE_COAX } from '../api';

export const useDeleteCoax = (propertyId: null | number) => {
  const queryClient = useQueryClient();

  const { data, mutate, isLoading, isError, isSuccess } = useMutation<string, unknown, { fiberId: string }>(
    async ({ fiberId }) =>
      requestGQL(DELETE_COAX, {
        propertyId,
        coaxialId: fiberId,
      }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['propertyConnection', propertyId]);
        queryClient.invalidateQueries(['propertyRadioConnection', propertyId]);
        queryClient.invalidateQueries(allPremisesKey(propertyId));
      },
    },
  );

  return { data, mutate, isLoading, isError, isSuccess };
};
